import { styled } from 'styled-components';

const Description_Box = ({ desc1, desc2, only }: any) => {
  return (
    <div style={only ? { padding: only } : {}}>
      <Box>
        <div style={{ color: '#008AFF' }}>{desc1}</div>
        <div style={{ color: '#616161' }}>{desc2}</div>
      </Box>
    </div>
  );
};

export default Description_Box;

const Box = styled.div`
  width: 100%;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background: #f4f8ff;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: calc(12px * -0.02);
`;
